import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('error');
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      const res = await axios.post('/api/admin/adminlogin', { username, password });

      if (res.data.message === 'Login successful') {
        // Use admin-specific localStorage keys
        localStorage.setItem('collegeAdminToken', res.data.token);
        localStorage.setItem('collegeAdminUser', JSON.stringify(res.data.admin));
        localStorage.setItem('collegeAdminRole', 'admin');

        setMessage('Login successful! Redirecting...');
        setMessageType('success');

        // Immediate navigation after setting localStorage
        navigate('/admin/dashboard', { replace: true });
      }
    } catch (err) {
      setMessage(err.response?.data?.message || 'Login failed');
      setMessageType('error');
    }
  };

  const handleCloseMessage = () => {
    setMessage('');
  };

  return (
    <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', height: '100vh', overflow: 'hidden' }}>
      {/* Left Image Section */}
      <div
        style={{
          flex: '0 0 60%',
          display: isMobile ? 'none' : 'block',
          backgroundImage: 'url("../images/studentloginimg.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      {/* Right Login Section */}
      <div
        style={{
          flex: '0 0 40%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF)',
          padding: '10px',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        {/* Card Section */}
        <div
          style={{
            width: '100%',
            maxWidth: '400px',
            backgroundColor: '#fff',
            padding: '20px',
            borderRadius: '16px',
            boxShadow: '0 0 20px rgba(0, 0, 0, 0.08)',
            display: 'flex',
            flexDirection: 'column',
            height: 'auto',
            maxHeight: '80vh',
            overflow: 'hidden',
          }}
        >
          <h3 style={{ textAlign: 'center', marginBottom: '16px', color: 'purple', fontFamily: "'Roboto', sans-serif" }}>
            Admin Login
          </h3>
          {/* Message Section - Moved inside card, under heading */}
          {message && (
            <div
              style={{
                backgroundColor: '#F3E8FF',
                color: '#6B21A8',
                fontFamily: "'Roboto', sans-serif",
                padding: '8px',
                borderRadius: '8px',
                textAlign: 'center',
                fontSize: '14px',
                maxWidth: '300px',
                width: '100%',
                margin: '0 auto 16px auto',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                animation: 'slideInFromRight 0.5s ease-out',
                overflow: 'hidden',
                whiteSpace: 'normal',
                maxHeight: '50px',
              }}
            >
              <span style={{ fontFamily: "'Roboto', sans-serif" }}>{message}</span>
              <FontAwesomeIcon
                icon={faTimes}
                style={{
                  cursor: 'pointer',
                  fontSize: '12px',
                  color: '#6B21A8',
                  fontFamily: "'Roboto', sans-serif",
                }}
                onClick={handleCloseMessage}
                aria-label="Close message"
              />
            </div>
          )}
          <form
            onSubmit={handleSubmit}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              alignItems: 'center',
              marginTop: '2rem', // Increased from 1rem to 2rem for more gap
              flex: '1',
              overflow: 'hidden',
            }}
          >
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              style={{
                padding: '10px 14px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
                maxWidth: '300px',
                width: '100%',
                fontFamily: "'Roboto', sans-serif",
              }}
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                padding: '10px 14px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
                maxWidth: '300px',
                width: '100%',
                fontFamily: "'Roboto', sans-serif",
              }}
            />
            <Link
              style={{
                textDecoration: 'none',
                color: 'purple',
                fontSize: '14px',
                fontWeight: 'bold',
                transition: 'text-decoration 0.3s ease',
                maxWidth: '300px',
                width: '100%',
                textAlign: 'right',
                fontFamily: "'Roboto', sans-serif",
              }}
              onMouseOver={(e) => (e.target.style.textDecoration = 'underline')}
              onMouseOut={(e) => (e.target.style.textDecoration = 'none')}
            >
            </Link>
            <button
              type="submit"
              style={{
                padding: '5px 20px',
                backgroundImage:
                  'linear-gradient(#fff, #fff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
                color: 'purple',
                fontWeight: 'bold',
                fontSize: '14px',
                border: '2px solid transparent',
                borderRadius: '30px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                marginTop: '12px',
                position: 'relative',
                top: '-12px',
                maxWidth: '300px',
                width: '35%',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                fontFamily: "'Roboto', sans-serif",
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'scale(1.03)';
                e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
              }}
            >
              Login
            </button>
          </form>
        </div>
      </div>
      <style>
        {`
          @keyframes slideInFromRight {
            0% {
              transform: translateX(100%);
              opacity: 0;
            }
            100% {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
};

export default AdminLogin;